// extracted by mini-css-extract-plugin
export var backdropBlur = "_lg-0";
export var contentCard = "_lg-5";
export var frame = "_lg-2";
export var image = "_lg-4";
export var imagePane = "_lg-3";
export var modal = "_lg-1";